import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SetProgressSpinnerVisiblity } from '../store';
import { finalize, map } from 'rxjs/operators';

@Injectable({ providedIn: "root" })
export class ProgressSpinnerInterceptor implements HttpInterceptor {

  constructor(private store: Store) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.store.dispatch(new SetProgressSpinnerVisiblity(true));
    return next.handle(request).pipe(finalize(() => this.store.dispatch(new SetProgressSpinnerVisiblity(false))));
  }
}
